module.exports = __webpack_public_path__ + "static/media/about-company-intro.36185c38.jpg";